<template>
    <div>

        <b-overlay :show="loading" rounded="sm">

            <div class="mb-4">

                <div class="h5 mb-2">

                    Anotações

                    <span v-b-tooltip.hover title="Clique na imagem abaixo para ver as anotações da sua redação">
                        <svg xmlns="http://www.w3.org/2000/svg" class="icons" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
                            <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                        </svg>
                    </span>

                </div>

                <b-alert variant="info" dismissible show>
                    Para você ver detalhes do seu texto, você pode clicar nas marcações dentro da imagem da redação.
                </b-alert>

            </div>

            <div class="mb-3">
                <img ref="essayAnnotation" :src="essay.preview" class="essay" alt="Redação do Aluno">
            </div>

        </b-overlay>

        <b-sidebar
            v-model="open"
            @close="cancelSelection"
            width="370px"
            title="Comentário"
            backdrop-variant="dark"
            right
            shadow
            backdrop
        >
            <div class="px-3 py-2" v-if="annotation">

                <div v-if="annotation.body.length === 0">
                    Não há comentário do professor na marcação :(
                </div>

                <div v-for="anno in annotation.body" :key="anno.id">
                    <div v-if="anno.purpose === 'field'">
                        <div class="h5">Referência</div>
                        <p class="text-muted">
                            {{ getDescription(anno.value) }}
                        </p>

                    </div>
                </div>

                <div v-for="anno in annotation.body" :key="anno.id">

                    <div v-if="anno.purpose === 'commenting' || anno.purpose === 'replying'">
                        <p>
                            {{ anno.value }}
                        </p>
                    </div>
                </div>

            </div>
        </b-sidebar>

    </div>
</template>

<script>
import { Annotorious } from '@recogito/annotorious';
import ColorSelectorWidget from "../../../../mixins/ColorSelectorWidget";
import ColorFormatter from "../../../../mixins/ColorFormatter";

export default {
    props: ['essay'],
    data() {
        return {
            loading: false,
            annotationInstance: null,
            id: null,
            annotation: null,
            open: false,
            modes: {
                fields: []
            }
        }
    },
    mounted() {

        this.annotationInstance = new Annotorious({
            image: this.$refs.essayAnnotation,
            locale: 'pt',
            readOnly: true,
            disableEditor: true,
            widgets: [
                ColorSelectorWidget,
                'COMMENT'
            ],
            formatter: ColorFormatter
        })

        this.annotationInstance.on('selectAnnotation', (annotation) => {
            this.annotation = annotation;
            this.open = true;
        });

        // Width Essay
        this.$refs.essayAnnotation.parentElement.style.width = '100%'

    },
    created() {

        this.id = this.essay.id

        this.getFields();
        // Loading Annotations
        this.load()

    },
    methods: {

        load() {
            this.loading = true;
            axios.get('/student/new-annotations/' + this.id)
                .then(async (result) => {
                    const response = result.data.data

                    // Format Annotations
                    let annotations = response.new_annotations.map(element => {

                        // element.data.body.push({
                        //     purpose: "ordering",
                        //     type: "TextualBody",
                        //     value: element.order
                        // })

                        return element.data;
                    })

                    // Set Annotations
                    this.annotationInstance.setAnnotations(annotations)

                })
                .finally(() => {
                    this.loading = false
                })
        },

        cancelSelection() {
            this.annotationInstance.cancelSelected()
            this.annotation = null
        },

        getDescription(value){
            const field = this.modes.fields.find(field => field.id === Number(value))

            return field.description ?? 'Não Encontrado.'
        },

        getFields(){
            
            axios.get('/student/modes/'+this.essay.id)
            .then((result) => {
                const response = result.data.data;
                let modes = null
                // Mode
                if (response.essay.theme) {
                    modes = response.essay.theme.mode;
                } else {
                    modes = response.essay.mode;
                }

                
                return this.modes = modes
            })
        }

    }
}
</script>

<style scoped>
    .icons{
        height: 20px;
    }
    .essay {
        width: 100%;
    }
</style>
